import { FC } from 'react';

import { SvgIconProps } from 'types/styles';
import { SvgIcon } from 'ui/SvgIcon';

export const ArrowLeftIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
      fill="currentColor"
    />
  </SvgIcon>
);
